import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import axios from 'axios';

const QuickSearch = ({ className = '', placeholder = '', onSelect, url, getValue, Suggestion }) => {
  const [ value, setValue ] = useState('');
  const [ suggestions, setSuggestions ] = useState([]);
  const [ fetchResultsByKeyword ] = useState({});
  const [ promisesByValue ] = useState({});
  const [ fetchTimeout, setFetchTimeout ] = useState();

  const getSuggestions = async value => {
    if (!value) {
      return [];
    }

    if (!promisesByValue[value]) {
      promisesByValue[value] = axios.post(url, {
        query: value,
      });
    }

    const { data } = await promisesByValue[value];

    return data;
  };

  const renderSuggestion = suggestion => (
    <Suggestion suggestion={suggestion} />
  );

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onSelect(suggestion);
  };

  const onSuggestionsFetchRequested = async ({ value }) => {
    clearTimeout(fetchTimeout);

    value = value?.trim();

    if (fetchResultsByKeyword[value]) {
      return fetchResultsByKeyword[value];
    }

    setFetchTimeout(setTimeout(async () => {
      const suggestions = await getSuggestions(value);
      setSuggestions(suggestions);
    }, 500));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: placeholder,
    value: value || '',
    onChange: onChange,
  };

  return (
    <div className={`quick-search ${className}`}>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionSelected={onSuggestionSelected}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </div>
  );
}

export default QuickSearch;
